<template>
  <div>
    <div class="headBox">
      <div class="headLeft">
        <van-popover
          placement="bottom-start"
          v-model="showPopover"
          trigger="click"
          class="group-popover"
        >
          <div class="group-list">
            <div
              :class="['ellipsis', 'item', item.id == groupId ? 'active' : '']"
              v-for="item in allGroupList"
              :key="item.id"
              @click="onGroupItem(item.id)"
            >
              {{ item.groupName }}({{ item.instanceList.length }})
            </div>
          </div>
          <template #reference>
            <div class="groupNowadayBox">
              <div class="groupNowaday" v-if="getGroupItem(groupId)">
                {{ getGroupItem(groupId).groupName }}({{
                  getGroupItem(groupId).instanceList.length
                }})
              </div>
              <img
                class="direction"
                v-if="showPopover"
                src="@/assets/icons/direction-up.png"
                alt=""
              />
              <img
                class="direction"
                v-else
                src="@/assets/icons/direction-bottom.png"
                alt=""
              />
            </div>
          </template>
        </van-popover>
      </div>
      <div class="headRight">
        <!-- <div class="topToolBox" @click="toActivationcodeusage">
          <div class="toolName">批量购买</div>
        </div> -->
        <div class="topToolBox">
          <div class="toolName" v-if="gonggeshow == 9" @click="handleGongge(1)">
            单视图展示
          </div>
          <div class="toolName" v-if="gonggeshow == 1" @click="handleGongge(9)">
            九宫格展示
          </div>
        </div>
        <div
          class="topToolBox refresh"
          :style="{ transform: `rotate(${currentRotation}deg)` }"
          @click="handleRefresh"
        >
          <img class="toolImg" src="@/assets/icons/refresh.png" alt="" />
        </div>
        <div class="topToolBox" @click="toBatchOperation">
          <img class="toolImg batch" src="@/assets/icons/batch.png" alt="" />
          <div class="toolName">批量操作</div>
        </div>
      </div>
    </div>
    <!-- <Loading v-model="isRotating" text="刷新中..."> </Loading> -->
  </div>
</template>
  
  <script>
import { mapState, mapMutations } from "vuex";
import Loading from "@/components/publicDialog/Loading.vue";
import { Toast } from "vant";
export default {
  name: "AochenHead",
  components: {
    Loading,
  },
  props: {
    allGroupList: {
      default: [],
      type: Array,
    },
    gonggeshow: {
      default: 1,
      type: Number,
    },
  },
  data() {
    return {
      cardList: [],
      showPopover: false,
      currentRotation: 360,
      isRotating: false,
    };
  },
  computed: {
    ...mapState("perpetual", ["groupId"]),
    getGroupItem: {
      get() {
        return function (groupId) {
          let item = this.allGroupList.find((item) => item.id == groupId);
          if (item) {
            return item;
          } else {
            return {
              id: -1,
              groupName: "所有分组",
              instanceList: [],
            };
          }
        };
      },
    },
  },
  methods: {
    ...mapMutations("perpetual", ["SET_GROUPID"]),
    onGroupItem(id) {
      if (this.groupId != id) {
        this.SET_GROUPID(id);
        this.showPopover = false;
        this.$emit("onGroup", id);
      } else {
        this.showPopover = false;
      }
    },
    toBatchOperation() {
      this.$auth.checkLogin(
        () => {
          this.$router.push("/batchOperation");
        },
        this.$router,
        this.$store.getters.token
      );
    },
    toActivationcodeusage() {
      this.$auth.checkLogin(
        () => {
          this.$router.push({
            path: "/newCloudPhone",
          });
        },
        this.$router,
        this.$store.getters.token
      );
    },
    handleRefresh() {
      this.$auth.checkLogin(
        () => {
          if (this.isRotating) return;
          this.isRotating = true;
          this.currentRotation += 360;
          this.$emit("refresh", "");
          setTimeout(() => {
            this.isRotating = false;
          }, 500);
        },
        this.$router,
        this.$store.getters.token
      );
    },
    handleGongge(type) {
      // 切换视图模式，通知父组件更新 gonggeshow
      this.$emit("changeGonggeshow", type);
    },
  },
};
</script>
  
  <style lang="less" scoped>
.headBox {
  font-family: MiSans, MiSans;
  padding: 0 16px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  // border-bottom: 1px solid #d3d4ff;

  .headLeft {
    display: flex;
    align-items: baseline;
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 0px 3 16px 0px rgba(140, 140, 140, 0.06);
    border-radius: 30px;
    padding: 5px 7px;
    .groupNowadayBox {
      display: flex;
      align-items: center;
      .groupNowaday {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 500;
        font-size: 12px;
        color: #333640;
        max-width: 100px;
      }
      .direction {
        width: 10px;
        height: 10px;
        margin-left: 4px;
      }
    }
  }
  .headRight {
    display: flex;
    .topToolBox {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 8px;
      background: rgba(255, 255, 255, 0.8);
      box-shadow: 0px 3 16px 0px rgba(140, 140, 140, 0.06);
      border-radius: 30px;
      padding: 5px 7px;
      .toolImg {
        width: 18px;
        height: 18px;
      }
      .toolName {
        font-weight: 500;
        font-size: 12px;
        color: #333640;
      }
      .batch {
        margin-right: 4px;
      }
    }
    .refresh {
      padding: 5px;
      transition: transform 0.5s ease-out;
      user-select: none;
    }
  }
}
.group-list {
  border-radius: 6px;
  box-shadow: 0 0 4rem rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 0.4px 0;
  text-align: center;
  width: 120px;
  max-height: 552px;
  cursor: pointer;
  .item {
    padding: 5px;
    font-weight: 500;
    font-size: 14px;
    color: #333640;
  }
  .active {
    color: #886df3;
  }
}
</style>